import { stats } from '../../../mocks/britfit';

const highlights = [
  { icon: 'ri-medal-line', title: 'Over a Decade of Expertise', desc: 'Serving UK motorists since 2012 with professional, reliable mobile tyre services.' },
  { icon: 'ri-map-pin-2-line', title: 'Nationwide Coverage', desc: 'Operating across England, Scotland, and Wales with an ever-expanding network of technicians.' },
  { icon: 'ri-time-line', title: 'Rapid Response', desc: 'Average arrival time of 60 minutes for emergency callouts — we know your time matters.' },
  { icon: 'ri-shield-check-line', title: 'Fully Guaranteed Work', desc: 'All fittings are covered by our workmanship guarantee. Your safety is our top priority.' },
];

export default function About() {
  return (
    <section id="about" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left — Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden h-80 md:h-[520px]">
              <img
                src="https://public.readdy.ai/ai/img_res/6788072dc3c02285cee549b88efd9dbe.jpg"
                alt="BritFit technician"
                className="w-full h-full object-cover object-top"
              />
            </div>

            {/* Floating badge */}
            <div className="absolute -bottom-5 -right-2 md:right-6 bg-[#1B4332] text-white rounded-2xl px-6 py-4 min-w-[180px]">
              <div className="text-3xl font-bold" style={{ fontFamily: 'Syne, sans-serif' }}>4.9 / 5</div>
              <div className="text-green-300 text-xs mt-1">Based on 2,400+ reviews</div>
              <div className="flex gap-0.5 mt-1.5">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-sm" />
                ))}
              </div>
            </div>
          </div>

          {/* Right — Content */}
          <div className="mt-8 lg:mt-0">
            <span className="inline-block bg-[#E8F5EE] text-[#1B4332] text-xs font-semibold px-4 py-1.5 rounded-full mb-5">
              About BritFit
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-stone-900 leading-tight mb-6" style={{ fontFamily: 'Syne, sans-serif' }}>
              British Quality.<br />
              Mobile Convenience.
            </h2>
            <p className="text-stone-500 text-sm leading-relaxed mb-8">
              Founded in 2012, BritFit Mobile Tyres has grown to become one of the UK&apos;s most trusted mobile tyre fitting services. We believe getting new tyres shouldn&apos;t mean spending hours at a garage — so we bring the garage to you.
            </p>
            <p className="text-stone-500 text-sm leading-relaxed mb-10">
              Our team of fully qualified, DBS-checked technicians operate across England, Scotland, and Wales, carrying a comprehensive range of premium tyres and the latest fitting equipment.
            </p>

            {/* Highlights */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-10">
              {highlights.map((h) => (
                <div key={h.title} className="flex gap-3">
                  <div className="w-9 h-9 flex-none flex items-center justify-center bg-[#E8F5EE] rounded-xl">
                    <i className={`${h.icon} text-[#1B4332]`} />
                  </div>
                  <div>
                    <div className="text-stone-900 text-sm font-semibold mb-0.5">{h.title}</div>
                    <div className="text-stone-400 text-xs leading-relaxed">{h.desc}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 pt-8 border-t border-stone-100">
              {stats.map((s) => (
                <div key={s.label}>
                  <div className="text-2xl font-bold text-[#1B4332]" style={{ fontFamily: 'Syne, sans-serif' }}>
                    {s.value}
                  </div>
                  <div className="text-stone-400 text-xs mt-0.5">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
